// ==================== CONSTANTS ====================

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: '/api/Auth/login',
  REGISTER: '/api/Auth/register',
  CHANGE_PASSWORD: '/api/Auth/change-password',
  GET_CURRENT_USER: '/api/Auth/me',
  UPDATE_PROFILE: '/api/Auth/profile',

  // User management endpoints (Admin only)
  GET_USERS: '/api/Auth/users',
  ACTIVATE_USER: '/api/Auth/users/{userId}/activate',
  DEACTIVATE_USER: '/api/Auth/users/{userId}/deactivate',

  // Certificate endpoints
  GET_CERTIFICATES: '/api/Certificates',
  GET_CERTIFICATES_WITHOUT_ATTACHMENTS: '/api/Certificates/Certificates/WithoutAttachments',
  EXPORT_EXCEL_CERTIFICATES_WITHOUT_ATTACHMENTS: '/api/Certificates/Certificates/WithoutAttachments/Excel',
  GET_CERTIFICATE_BY_ID: '/api/Certificates/{id}',
  CREATE_CERTIFICATE: '/api/Certificates',
  UPDATE_CERTIFICATE: '/api/Certificates/{id}',
  DELETE_CERTIFICATE: '/api/Certificates/{id}',
  GET_CERTIFICATE_PDF: '/api/Certificates/{id}/pdf',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  OFFICE: 'office',
};

export const PERMISSIONS = {
  // Admin permissions
  VIEW_USERS: 'view_users',
  MANAGE_USERS: 'manage_users',
  CREATE_USERS: 'create_users',
  ACTIVATE_USER: 'activate_user',
  DEACTIVATE_USER: 'deactivate_user',

  // Certificate permissions
  VIEW_CERTIFICATES: 'view_certificates',
  CREATE_CERTIFICATES: 'create_certificates',
  EDIT_CERTIFICATES: 'edit_certificates',
  DELETE_CERTIFICATES: 'delete_certificates',

  // Statistics
  VIEW_STATISTICS: 'view_statistics',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  CERTIFICATES: '/certificates',
  CERTIFICATES_WITHOUT_ATTACHMENTS: '/certificates-without-attachments',
  CREATE_CERTIFICATE: '/certificates/create',
  EDIT_CERTIFICATE: '/certificates/edit/:id',
  UNAUTHORIZED: '/unauthorized',
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER_DATA: 'userData',
  THEME_MODE: 'themeMode',
};

export const APP_CONFIG = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:5009',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'COC Management',
  COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME || 'SafqaSoft Solutions',
  REQUEST_TIMEOUT: 30000,
  DEFAULT_PAGE_SIZE: 10,
};
